import React, { useState } from 'react';
import classNames from 'classnames';

import { hasHelpChannels } from '../../config/communityChannels';
import {
  buildConciergeMessage,
  copyConciergeTextAndOpen,
  getConciergeLinks,
} from '../../util/conciergeIntake';

import css from './SimpleAppExperience.module.css';

/**
 * Concierge path: open WhatsApp with prefilled brief, or Telegram (+ clipboard copy).
 */
const ConciergeIntakeBar = ({
  appId,
  job,
  brief,
  title,
  className,
  onRequested,
  requested = false,
  compact = false,
}) => {
  const [copied, setCopied] = useState(false);
  if (!hasHelpChannels()) {
    return null;
  }

  const { text, links } = getConciergeLinks({ appId, job, brief, title });
  if (!links.length) {
    return null;
  }

  const handleClick = async (link, e) => {
    if (link.id === 'telegram') {
      e.preventDefault();
      const ok = await copyConciergeTextAndOpen(link.href, text);
      setCopied(ok);
    }
    if (onRequested) {
      onRequested({ channel: link.id, text });
    }
  };

  return (
    <div
      className={classNames(css.conciergeBlock, className)}
      data-testid="concierge-intake"
    >
      {!compact ? (
        <h3 className={css.jobBlockTitle}>Concierge match</h3>
      ) : null}
      <p className={css.cardBlurb}>
        {requested
          ? 'Ops was notified from this device — keep this thread open for updates.'
          : 'No fit in the directory? Send this request to WhatsApp or Telegram. Moderators match you manually — you do not wait for organic supply.'}
      </p>
      <div className={css.actionRow}>
        {links.map(link => (
          <a
            key={link.id}
            href={link.href}
            className={link.id === 'whatsapp' ? css.primaryBtn : css.secondaryBtn}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`concierge-${link.id}`}
            onClick={e => handleClick(link, e)}
          >
            {link.id === 'whatsapp' ? 'WhatsApp ops' : 'Telegram ops'}
          </a>
        ))}
      </div>
      {copied ? (
        <p className={css.cardMeta} data-testid="concierge-copied">
          Brief copied — paste into Telegram if needed.
        </p>
      ) : null}
      {!compact ? (
        <details className={css.techDetails}>
          <summary className={css.techSummary}>Preview message</summary>
          <pre className={css.techBody} style={{ whiteSpace: 'pre-wrap', fontSize: 12 }}>
            {buildConciergeMessage({ appId, job, brief, title })}
          </pre>
        </details>
      ) : null}
    </div>
  );
};

export default ConciergeIntakeBar;
